import { createMutationHook } from '~/shared/providers/api';

export const useUpdateFreightLaneMutation = createMutationHook(
  'transportation.freightLaneUpdate',
  (params: {
    id: string;
    carrierId?: string;
    transportationMode?: string;
    active?: boolean;
    freightLaneRouteId?: string;
    equipmentType?: string | null;
    commodityCategory?: string | null;
    originLocationId?: string | null;
    originLocationType?: string | null;
    destinationCity?: string | null;
    destinationState?: string | null;
    destinationZipCode?: string | null;
    destinationCountry?: string | null;
    notes?: string | null;
  }) => ({
    transportationFreightLaneUpdate: {
      __args: {
        id: params.id,
        input: {
          carrierId: params.carrierId,
          transportationMode: params.transportationMode,
          active: params.active,
          freightLaneRouteId: params.freightLaneRouteId,
          equipmentType: params.equipmentType,
          commodityCategory: params.commodityCategory,
          originLocationId: params.originLocationId,
          originLocationType: params.originLocationType,
          destinationCity: params.destinationCity,
          destinationState: params.destinationState,
          destinationZipCode: params.destinationZipCode,
          destinationCountry: params.destinationCountry,
          notes: params.notes,
        },
      },
      id: true,
      carrierId: true,
      transportationMode: true,
      equipmentType: true,
      commodityCategory: true,
      active: true,
      notes: true,
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
);
